import { getBlockToolCallName } from './generate-prompt';
import { transformIntakeFormFieldToSchema } from './transform-schema';
export const VALIDATE_INTAKE_FUNCTION = {
    name: 'validate_intake',
    description: 'Validates the collected intake form data to ensure all required fields are provided and meet validation criteria. Use this tool before completing the intake process to verify data completeness and accuracy.'
};
const describeFieldsByRequirement = (fields) => {
    const names = (matches) => fields
        .filter(matches)
        .map((f) => f.name)
        .join(', ');
    return [
        ['Required fields', names((f) => !!f.required && !f.condition)],
        [
            'Required only if their condition is met',
            names((f) => (!!f.required && !!f.condition) || (!f.required && !!f.requiredWhen))
        ],
        [
            'Optional fields (ask when they apply, but allowed to skip if unknown)',
            names((f) => !f.required && !f.requiredWhen)
        ]
    ]
        .filter(([, list]) => list)
        .map(([label, list]) => ` ${label}: ${list}.`)
        .join('');
};
// Listing every field as required is the default: older models skipped any field the line left out
export const generateToolConfigFromBlock = (block, requiredFieldsOnly = false) => {
    const functionName = getBlockToolCallName(block.title);
    const functionDescription = requiredFieldsOnly
        ? `Save information about ${block.title}.${describeFieldsByRequirement(block.fields)}`
        : `Save information about ${block.title}. Required fields: ${block.fields.map((f) => f.name).join(', ')}`;
    const properties = block.fields.reduce((acc, field) => {
        acc[field.name] = transformIntakeFormFieldToSchema(field);
        return acc;
    }, {});
    return {
        functionName,
        functionDescription,
        functionParameters: {
            type: 'object',
            properties
        }
    };
};
//# sourceMappingURL=intake-tool-functions.js.map